import MessengerIntegration from './MessengerIntegration'

export default MessengerIntegration
